/**
 * Transforme les horaires du format frontend vers le format backend
 * Frontend: [{ jour: 'LUNDI', creneaux: [{ heureDebut, heureFin, actif }] }]
 * Backend: [{ jour: 1, heureDebut, heureFin, actif, ordre }]
 */
const cleanValue = (value) => {
  if (value === undefined || value === null) return null;
  const text = String(value).trim();
  return text === '' ? null : text;
};

export function frontendToBackend(horairesFrontend) {
  const joursMapping = {
    'LUNDI': 1, 'MARDI': 2, 'MERCREDI': 3, 'JEUDI': 4, 
    'VENDREDI': 5, 'SAMEDI': 6, 'DIMANCHE': 0
  };
  
  const horairesBackend = [];
  
  horairesFrontend.forEach(horaire => {
    if (horaire.creneaux && Array.isArray(horaire.creneaux)) {
      horaire.creneaux.forEach((creneau, index) => {
        const jourNum = joursMapping[horaire.jour];
        if (jourNum !== undefined) {
          const libelleLieu = cleanValue(creneau.libelleLieu);
          const adresseLigne1 = cleanValue(creneau.adresseLigne1);
          const adresseLigne2 = cleanValue(creneau.adresseLigne2);
          const codePostal = cleanValue(creneau.codePostal);
          const ville = cleanValue(creneau.ville);
          const latitude = cleanValue(creneau.latitude);
          const longitude = cleanValue(creneau.longitude);

          const payload = {
            jour: jourNum,
            heureDebut: creneau.heureDebut || '',
            heureFin: creneau.heureFin || '',
            ordre: index,
            actif: Boolean(creneau.actif)
          };

          if (libelleLieu !== null) payload.libelleLieu = libelleLieu;
          if (adresseLigne1 !== null) payload.adresseLigne1 = adresseLigne1;
          if (adresseLigne2 !== null) payload.adresseLigne2 = adresseLigne2;
          if (codePostal !== null) payload.codePostal = codePostal;
          if (ville !== null) payload.ville = ville;
          if (latitude !== null) payload.latitude = latitude;
          if (longitude !== null) payload.longitude = longitude;

          horairesBackend.push(payload);
        }
      });
    }
  });
  
  return horairesBackend;
}

/**
 * Transforme les horaires du format backend vers le format frontend
 * Backend: [{ jour: 1, heureDebut, heureFin, actif, ordre }]
 * Frontend: [{ jour: 'LUNDI', creneaux: [{ heureDebut, heureFin, actif }] }]
 */
export function backendToFrontend(horairesBackend) {
  const joursMapping = {
    0: 'DIMANCHE', 1: 'LUNDI', 2: 'MARDI', 3: 'MERCREDI', 
    4: 'JEUDI', 5: 'VENDREDI', 6: 'SAMEDI'
  };
  
  const byJour = new Map();
  
  (Array.isArray(horairesBackend) ? horairesBackend : []).forEach(h => {
    const jourStr = joursMapping[h.jour];
    if (!jourStr) return;
    
    if (!byJour.has(jourStr)) {
      byJour.set(jourStr, { jour: jourStr, creneaux: [] });
    }
    
    byJour.get(jourStr).creneaux.push({
      heureDebut: h.heureDebut || '',
      heureFin: h.heureFin || '',
      actif: Boolean(h.actif),
      ordre: h.ordre || 0,
      libelleLieu: h.libelleLieu || '',
      adresseLigne1: h.adresseLigne1 || '',
      adresseLigne2: h.adresseLigne2 || '',
      codePostal: h.codePostal || '',
      ville: h.ville || '',
      latitude: h.latitude !== undefined && h.latitude !== null ? String(h.latitude) : '',
      longitude: h.longitude !== undefined && h.longitude !== null ? String(h.longitude) : ''
    });
  });
  
  // Tri par jour et par ordre
  return [...byJour.entries()]
    .sort((a, b) => {
      const joursOrder = ['DIMANCHE', 'LUNDI', 'MARDI', 'MERCREDI', 'JEUDI', 'VENDREDI', 'SAMEDI'];
      return joursOrder.indexOf(a[0]) - joursOrder.indexOf(b[0]);
    })
    .map(([, val]) => ({
      ...val,
      creneaux: [...val.creneaux].sort((a, b) => (a.ordre || 0) - (b.ordre || 0))
    }));
}

/** True si au moins un créneau a une adresse de retrait complète (ligne 1 + CP + ville). */
export function hasItinerantRetraitAddress(horairesFrontend = []) {
  if (!Array.isArray(horairesFrontend)) return false;
  return horairesFrontend.some(
    (jour) =>
      Array.isArray(jour?.creneaux) &&
      jour.creneaux.some(
        (creneau) =>
          Boolean(String(creneau?.adresseLigne1 || '').trim()) &&
          Boolean(String(creneau?.codePostal || '').trim()) &&
          Boolean(String(creneau?.ville || '').trim())
      )
  );
}

